import { createRoot } from "react-dom/client";
import { SpeedInsights } from "@vercel/speed-insights/react";
import { Analytics } from "@vercel/analytics/react";
import "lenis/dist/lenis.css";
import { App } from "./App";

// Always start at the top on refresh. The .tac2 cinematic snaps the user
// to its settled Y on first crossing of the wand-tap threshold — if the
// browser restored scroll into or past that section, that trigger would
// fire on mount and yank them back to the wand strike.
if ("scrollRestoration" in history) history.scrollRestoration = "manual";
window.scrollTo(0, 0);

function Root() {
  return (
    <>
      <App />
      <SpeedInsights />
      <Analytics />
    </>
  );
}

const container = document.getElementById("root");
if (!container) throw new Error("#root element not found");

createRoot(container).render(<Root />);
